// extracted by mini-css-extract-plugin
export default {"text":"styles_text__jtm88","button":"styles_button__fCsYL"};